import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


import backlogo from '../../Assets/App_icon/back.png';
import gmaplogo from '../../Assets/App_icon/gmap.png';

const OrderMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false);
 
  const [packTransmodalVisible, setPackTransModalVisible] = useState(false);
  const [prdmodalVisible, setPrdModalVisible] = useState(false);  
  const [addPrdmodalVisible, setAddPrdModalVisible] = useState(false);    
  const [ledgerModalVisible, setLedgerModalVisible] = useState(false);  
  const [salesDetailModalVisible, setSalesDetailModalVisible] = useState(false);  
  
  const [areas, setAreas] = useState([]);
  const [packers, setPackers] = useState([]);
  const [selectPackers, setSelectPackers] = useState('');
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [chekedOrders, setChekedOrders] = useState([]);
  const [chekedPackOrders, setChekedPackOrders] = useState([]);
  const [chekedPackTransOrders, setChekedPacTranskOrders] = useState([]);

  const [selectedOrderDetail, setSelectedOrderDetail] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  

  const [newQty, setNewQty] = useState('');
  const [selectedProductRate, setSelectedProductRate] = useState(null); 
  const [selectedProductWR, setSelectedProductWR] = useState(null);   
  const [tempAmt, setTempAmt] = useState(1);   
  const [remark, setRemark] = useState('');
  const [ledgerData, setLedgerData] = useState([]);
  const [selectedLedgerData, setSelectedLedgerData] = useState([]);
  const [selectedSalesDetail, setSelectedSalesDetail] = useState([]);

  const fetchOrderList = async () => { 
      try {
        const response = await fetch(`${host_url}/packing_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
            'userid': localStorage.getItem('userid'),
          },
          body: JSON.stringify({
            type: 'list',
            store: store,
          }),
        });

        if (response.status === 401) {
          localStorage.clear();
          alert('Your account has been disabled.');
          window.location.href = "/";
          return;
        }

        const data = await response.json();
        setOrders(data);
        console.log(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }   
  }; 

  const handleBack = () => {
    navigate('../dashboard');
  };

    useEffect(() => {
      document.title = "Packing Master";
    }, []); // for Title Set

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible) {
            if (prdmodalVisible || addPrdmodalVisible || ledgerModalVisible || salesDetailModalVisible) {
              if(salesDetailModalVisible){
                  setSalesDetailModalVisible(false);
                  setLedgerModalVisible(true);
              } else {
                setPrdModalVisible(false);
                setAddPrdModalVisible(false);
                setLedgerModalVisible(false);
              }
              
            } else {
              setModalVisible(false);
              setAddModalVisible(false);
            }
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert") {
          if (modalVisible) {
            setAddPrdModalVisible(true);
          } else {
            setAddModalVisible(true);
          }
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible, prdmodalVisible, addPrdmodalVisible, ledgerModalVisible, salesDetailModalVisible]);

    useEffect(() => { 
      const fetchAreaList = async () => {      
          try {
            const response = await fetch(`${host_url}/area_list`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                areaId : '',
                areaName: '',
                areaEName: '',
              }),
            });
            const data = await response.json();
            setAreas(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchAreaList(); 
    }, [host_url, store]);  // AreaList
    
    useEffect(() => { 
      const fetchPackerList = async () => {      
          try {
            const response = await fetch(`${host_url}/user_list`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                suId : '',
                suName: '',
                suMo: '',
                suRole: '',
                suStatus: '',
              }),
            });
            const data = await response.json();
            const packersData = data.filter(item => item.suRole === 'Packers');
            setPackers(packersData);
            setSelectPackers(packersData[0].suId);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchPackerList(); 
    }, [host_url, store]);  // PackersList

    useEffect(() => {       
       fetchOrderList();      
    }, [host_url, store]); // OrderList

    useEffect(() => {
      setChekedPackOrders(chekedOrders.filter(order => order.ordStatus === 'Booked'));
      setChekedPacTranskOrders(chekedOrders.filter(order => order.ordStatus === 'Packing'));
    }, [chekedOrders]); // ChekBox Checked

    useEffect(() => {       
        const updatedOrderDetails = selectedOrderDetail.map(item => {
            if (item.ord_detail_id === selectedProduct.ord_detail_id) {
                return {
                    ...item, // Make a copy of the current item
                    prd_qty: selectedProduct.prd_qty, // Update qty
                    prd_unit: selectedProduct.prd_unit, // Update unit
                    prd_weight: selectedProduct.prd_weight, // Update weight
                    prd_amt: selectedProduct.prd_amt,
                    pack_status: selectedProduct.pack_status,
                };
            }
            return item;
        });

        if (JSON.stringify(selectedOrderDetail) !== JSON.stringify(updatedOrderDetails)) {
            setSelectedOrderDetail(updatedOrderDetails); 
        }
    }, [selectedProduct]); // Product Detail Update

    useEffect(() => {
      setTempAmt(selectedProductRate * newQty);
    }, [newQty]);
    
    const [custIdFilter, setCustIdFilter] = useState('');
    const [custNameFilter, setCustNameFilter] = useState('');
    const [custAreaFilter, setCustAreaFilter] = useState('');
    const [packFilter, setPackFilter] = useState('');

    const filteredOrders = orders.filter(orders =>
      String(orders.custId).toLowerCase().includes(custIdFilter.toLowerCase()) &&
      orders.custName.toLowerCase().includes(custNameFilter.toLowerCase()) &&
      orders.custAreaName.toLowerCase().includes(custAreaFilter.toLowerCase()) &&
      orders.ordDelPackName.toLowerCase().includes(packFilter.toLowerCase()) 
    );

    const totalCount = filteredOrders.length;
    const totalItems = filteredOrders.reduce((sum, order) => sum + Number(order.ordItems), 0);
    const totalPackedItems = filteredOrders.reduce((sum, order) => sum + Number(order.ordPackedItems), 0);
    const totalWeight = filteredOrders.reduce((sum, order) => sum + Number(order.ordWeight), 0);
    const totalAmt = filteredOrders.reduce((sum, order) => sum + Number(order.ordAmt), 0);

    const detailtotalWeight = selectedOrderDetail.reduce((sum, product) => sum + Number(product.prd_weight), 0);
    const detailtotalAmt = selectedOrderDetail.reduce((sum, product) => sum + Number(product.prd_amt), 0);

    const handleOrderDetail = async (order) => {
      setModalVisible(true);
      setSelectedOrder(order);
      setRemark(order.ordRemark);
      setSelectedOrderDetail([]);
      const ordDetail = {
            ord_no: order.ordNo,
        };
      try {
        const response = await fetch(`${host_url}/order_select`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'list', 
            store: store, 
            orddetail: ordDetail,  
          }),
        });
        const data = await response.json();
        setSelectedOrderDetail(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleToPackersTrans = async () => {
      setPackTransModalVisible(false);
      try {
        const response = await fetch(`${host_url}/packing_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'pack_update', 
            store: store, 
            packId: selectPackers, 
            suId: '',
            ordNo: '',
            prddetail: chekedPackTransOrders,  
          }),
        });
        const data = await response.json();
        setOrders(data);;
        setChekedOrders([]);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleCheckboxChange = (e, row, isChecked) => {
      if (isChecked) {
        setChekedOrders([...chekedOrders, row]);
      } else {
        setChekedOrders(chekedOrders.filter(order => order.ordNo !== row.ordNo));
      }
    };

    const handleSelectAllChange = (e) => {
      const isChecked = e.target.checked;
      
      if (isChecked) {
        setChekedOrders(filteredOrders);
      } else {
        // Deselect all checkboxes
        setChekedOrders([]);
      }
    };
   
    const handleProductDetail = async (product) => {
      setSelectedProduct(product);
      setNewQty(product.prd_qty);
      setSelectedProductRate(product.prd_amt / product.prd_qty);
      setSelectedProductWR((product.prd_weight / product.prd_qty).toFixed(3));
      setPrdModalVisible(true);
    };

    const handleProductUpdate = async () => {
      setPrdModalVisible(false);
        const updatedQty = newQty;
        const updateweight = selectedProductWR * updatedQty;
        const updateamt = selectedProductRate * updatedQty;
        let updateunit;
        let tempunit;
        const [weight, unit] = selectedProduct.prd_unit.split(" ");
        

        if(updatedQty < 1 && updatedQty > 0 ){
          if (unit === 'gms' ) {
             updateunit = `${updatedQty * 1000} gms`;
          } else {
             updateunit = `${updatedQty * 1000} ગ્રામ`; 
          }
        } else if(unit.toLowerCase() === 'kg' || unit === 'કિલો' ) {
            tempunit = unit.toLowerCase() === 'kg' ? 'kg' : 'કિલો';
            updateunit = `${Number(updatedQty).toFixed(3)} ${tempunit}`;
        } else {
          updateunit = `${Number(updatedQty).toFixed(0)} ${unit}`;
        }

        setSelectedProduct((prevItem) => ({
          ...prevItem, 
          prd_weight: updateweight, 
          prd_unit: updateunit,
          prd_qty: updatedQty, 
          prd_amt: Math.round(updateamt), 
          pack_status: 'Y',
        }));   

            try {
              const response = await fetch(`${host_url}/pack_update_prd_detail`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  store: store,
                  ord_detail_id: selectedProduct.ord_detail_id,
                  prd_weight: updateweight,
                  prd_qty: updatedQty,
                  prd_unit: updateunit,
                  prd_amt: Math.round(updateamt), 
                  pack_status: 'Y',
                  order_no: selectedProduct.ord_no,
                  order_amt: ''

                }),
              });
              
              await response.json();
              
            } catch (error) {
              console.error('Error fetching orderList:', error);
            }
            fetchOrderList();
    };  
    
    const handleProductDelete = async () => {
        const userConfirmed = window.confirm('Are you sure you want to delete this product?');
        if (userConfirmed) {
          const ordDetail = {
              ord_no: selectedOrderDetail[0].ord_no,
              ord_detail_id: selectedProduct.ord_detail_id,
          };

          try {
            const response = await fetch(`${host_url}/order_select`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'Delete_Product', 
                store: store, 
                orddetail: ordDetail,
              }),
            });
            const data = await response.json();
            setSelectedOrderDetail(data);
            setPrdModalVisible(false);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          fetchOrderList();
        }
    };

    const handleReadyForDelivery = async () => {
      setModalVisible(false);
      try {
        const response = await fetch(`${host_url}/packing_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'status_update', 
            store: store, 
            packId: selectedOrder.ordPackId, 
            suId: '',
            ordNo: selectedOrder.ordNo,
            prddetail: '',  
          }),
        });
        const data = await response.json();
        setOrders(data);;
        setChekedOrders([]);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleUpdateRemark = async () => {
      if(selectedOrder.ordRemark != remark) {
        const ordDetail = {
              ord_no: selectedOrder.ordNo,
              ord_remark: remark,
          };
          
          try {
            const response = await fetch(`${host_url}/order_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'remark_update', 
                store: store, 
                ordersList: ordDetail,
              }),
            });
            const data = await response.json();
            setOrders(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }

      }      
    };

    const printLabel50x30 = () => {
      const width = 400;
      const height = 300;

      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      const printWindow = window.open(
        "",
        "",
        `width=${width},height=${height},left=${left},top=${top}`
      );

      const formatCustId = () => {
        const str = String(selectedOrder.custId);
        if (str.length <= 5) return str;
        return str.slice(0, 5) + "  " + str.slice(5);
      };

      printWindow.document.write(`
        <html>
          <head>
            <title>Print Label</title>
            <style>
              @page {
                size: 50mm 25mm;
                margin: 0;
              }

              html, body {
                width: 50mm;
                margin: 0;
                padding: 0;
              }

              body {
                font-family: Arial, sans-serif;
                font-size: 14px;
                text-align: center;
              }

              .label {
                width: 50mm;
                height: 25mm;
                box-sizing: border-box;
                padding: 2mm;
                overflow: hidden;
              }

              .cust-name {
                font-weight: bold;
                font-size: 14px;
                line-height: 1.3;
                white-space: normal;
                word-break: break-word;
              }

              .spacer {
                height: 1mm;   /* 👈 adjust this as needed */
              }
              .spacerArea {
                height: 2mm;   /* 👈 adjust this as needed */
              }
            </style>
          </head>
          <body>
            <div class="label">
              <div class="spacerArea"></div>
              <div class="cust-name">${selectedOrder.custAreaGName}</div>
              <div class="spacer"></div>
              <div class="cust-name">${formatCustId()}</div>
              <div class="cust-name">${selectedOrder.custGName}</div>
            </div>
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.focus();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 300);
    };

    const handleCustLedger = async (custId) => {
      setLedgerModalVisible(true);
      try {
        const response = await fetch(`${host_url}/cust_ledger`, {
        method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            custId: custId,
            lang: 'Gujarati',
            store: store
          }),
        });

        const data = await response.json();
        setLedgerData(data);
        console.log(data);
      } catch (error) {
        console.error('Error updating profile:', error);
      }
    };

    const handleSalesDetail = async (sale) => {

      setSalesDetailModalVisible(true);
      setLedgerModalVisible(false);
      setSelectedSalesDetail([]);
      setSelectedLedgerData(sale);
      const salesDetail = {
            sl_id: sale.tr_id,
        };
      try {
        const response = await fetch(`${host_url}/sales_select`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'list', 
            store: store, 
            salesdetail: salesDetail,  
          }),
        });
        const data = await response.json();
        setSelectedSalesDetail(data);
        console.log("selectedSalesDetail", data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }  
    };

    
  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Packing Master</b>
                <div>
                  
                </div>
          </div>
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th colSpan='2'>
                    <span style={{ display: 'flex', paddingLeft: '10px' }}>
                      <span>
                        <input
                          type="checkbox"
                          value="selectAll"
                          onChange={(e) => handleSelectAllChange(e)}
                        />
                      </span>
                      <span style={{ paddingLeft: '10px' }}>Cust Id</span>
                    </span>
                </th>        
                <th colSpan='2'>Name</th>
                <th colSpan='2'>Area</th>
                <th>Item</th>
                <th>Weight</th>
                <th>Amount</th>
                <th colSpan='2'>Packers</th>
              </tr>
              <tr>
                 <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={custIdFilter}
                    onChange={(e) => setCustIdFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={custNameFilter}
                    onChange={(e) => setCustNameFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    style={{fontSize: '14px' }}
                    value={custAreaFilter}
                    onChange={(e) => setCustAreaFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    {areas.map((area) => (
                      area.order > 0 && (
                        <option key={area.areaId} value={area.areaEName}>
                          {area.areaEName}
                        </option>
                      )
                    ))}
                  </select>
                </th>
                <th></th>
                <th></th>
                <th></th>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    style={{fontSize: '14px' }}
                    value={packFilter}
                    onChange={(e) => setPackFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    {packers.map((packer, index) => (
                      packer.suId !== 0 && (
                        <option key={index} value={packer.suName}>
                          {packer.suName}
                        </option>
                      )
                    ))}
                  </select>
                </th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredOrders.map((row, index) => {
                  return (
                    <tr key={index} style={{ lineHeight: '10px' }} onClick={() => handleOrderDetail(row)}>
                      <td colSpan='2' onClick={(e) => {
                        e.stopPropagation();  
                        const checkbox = e.target.querySelector('input[type="checkbox"]');
                        if (checkbox) {
                          checkbox.checked = !checkbox.checked;
                          handleCheckboxChange(e, row, checkbox.checked);
                        }
                      }}>
                        <span style={{ display: 'flex', paddingLeft: '10px' }}>
                          <span>
                            <input
                              type="checkbox"
                              value={row.ordNo}
                              checked={chekedOrders.some(order => order.ordNo === row.ordNo)}
                              onChange={(e) => handleCheckboxChange(e, row, e.target.checked)}
                            />
                          </span>
                          <span style={{ paddingLeft: '10px' }} >{row.custId}</span>
                        </span>
                      </td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.custName}</span></td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.custAreaName}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordItems} ( {row.ordPackedItems} )</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordWeight}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordAmt}</span></td>
                      <td colSpan='2' className="cell-left">
                        <span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.ordDelPackName}</span>
                      </td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                <th colSpan='4'>
                    {chekedOrders.length > 0 && chekedOrders.some(order => order.ordStatus === 'Packing') && (
                      <Button color="warning" style={{ marginTop: '5px', marginBottom: '5px', width: '80%', paddingTop: '0px', paddingBottom: '0px', fontSize: '16px' }} onClick={() => setPackTransModalVisible(true)} >To Packing Transfer</Button>
                    )}   
                </th>
                <th className="cell-right" ><span style={{ paddingRight: '10px' }}>{totalItems} ( {totalPackedItems} )</span></th>
                <th className="cell-right" ><span style={{ paddingRight: '10px' }}>{totalWeight.toFixed(3)}</span></th>
                <th className="cell-right" ><span style={{ paddingRight: '10px' }}>{totalAmt}</span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>

              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Order Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Packing Detail</h5>  
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '48%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th colSpan='3' className="cell-left" style={{ padding: '2px' }} >Item</th>
                          <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >Qty</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px', }} >Status</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {selectedOrderDetail.map((row, index) => {
                            return (
                                <tr key={index} style={{ cursor: 'pointer', height: '40px', color: row.pack_status === 'Y' ? 'initial' : 'red' }} onClick={() => handleProductDetail(row)}>
                                  <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                                  <td colSpan='2'className="cell-left" style={{ padding: '2px', fontSize: '14px' }} >{row.prd_unit}</td>
                                  <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.prd_amt}</td>
                                </tr>
                            );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan='3' className="cell-left"style={{ padding: '2px' }} >Total</th>
                          <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >{detailtotalWeight.toFixed(3)}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalAmt}</th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left" style={{ width: '25%'}} >{selectedOrder.custId} </td>
                          <td className="cell-left" style={{ width: '75%', cursor: 'pointer' }}  onClick={() => printLabel50x30( selectedOrder.custAreaGName, selectedOrder.custId, selectedOrder.custAreaGName) }>{selectedOrder.custGName}</td>
                        </tr>
                        <tr>
                          <td className="cell-left">Mo No :</td>
                          <td className="cell-left"> 
                                <a 
                                  href={`whatsapp://send?phone=91${selectedOrder.custMo}`} 
                                  style={{ textDecoration: "none", color: "inherit" }}
                                >
                                  {selectedOrder.custMo}
                                </a> 
                          </td>
                        </tr>
                        <tr>
                          <td className="cell-left">
                            {selectedOrder?.custLocation ? (
                              <a
                                href={`https://www.google.com/maps?q=${selectedOrder.custLocation.y},${selectedOrder.custLocation.x}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ cursor: "pointer" }}
                              >
                                <img 
                                  src={gmaplogo}   // your google map image
                                  alt="Map" 
                                  style={{ width: "20px", height: "20px" }} 
                                />
                              </a>
                            ) : (
                              "Add :"
                            )}
                          </td>
                          <td className="cell-left">{selectedOrder.custAdd}</td>
                        </tr>
                         <tr>
                          <td className="cell-left">Area :</td>
                          <td className="cell-left">{selectedOrder.custAreaGName}</td>
                        </tr>
                        <tr>
                          <td className="cell-left">Balance :</td>
                          <td className="cell-left" > <span  style={{ color: Number(selectedOrder.custBalance) < 0 ? 'red' : 'inherit', cursor: "pointer" }} onClick={() => handleCustLedger(selectedOrder.custId)}>{selectedOrder.custBalance}</span></td>
                        </tr>
                        <tr>
                          <td className="cell-left">Remark :</td>
                          <td className="cell-left" style={{ color: 'red' }}> 
                            <textarea 
                              style={{ backgroundColor: 'transparent', color: 'red',  border: '1px solid #ccc',  outline: 'none' }}
                              value={remark} 
                              onChange={(e) => setRemark(e.target.value)} 
                              onBlur={handleUpdateRemark}
                              rows="3" 
                            />
                          </td>
                        </tr>
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                              {selectedOrderDetail.length == selectedOrderDetail.filter(item => item.pack_status === 'Y').length && (
                                <Button color="success" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={handleReadyForDelivery} >
                                  Ready For Delivery
                                </Button>
                              )}
                              <Button color="primary" style={{ flex: 1, marginRight: '10px' }} onClick={() => setModalVisible(false)}>
                                Close
                              </Button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>

          {/* Modal for Product Detail */}
            <Modal isOpen={prdmodalVisible} toggle={() => setModalVisible(!prdmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >{selectedProduct.prd_name}</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td>Weight : </td>
                          <td style={{ padding: '2px' }} >
                              <input
                                type="text"
                                value={newQty} 
                                onChange={(e) => setNewQty(e.target.value)}            
                              />
                          </td>    
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="danger" style={{ flex: 1, marginRight: '10px' }} onClick={handleProductDelete} disabled={selectedOrder.ordStatus === 'Out For Delivery' || selectedOrder.ordStatus === 'Ready For Delivery'}>
                      Delete Product
                    </Button>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleProductUpdate} disabled={!tempAmt}>
                      Complete
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setPrdModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>        

          {/* Modal for To Packing Transfer */}
            <Modal isOpen={packTransmodalVisible} toggle={() => setModalVisible(!packTransmodalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                        <thead >
                          <tr >
                            <th >Cust Id</th>        
                            <th colSpan='2'>Name</th>
                            <th colSpan='2'>Area</th>
                            <th>Item</th>
                            <th>Weight</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody className="scrollable-body">
                          {chekedPackTransOrders.map((row, index) => {
                              return (
                                <tr key={index} style={{ lineHeight: '10px' }} >
                                  <td><span style={{ paddingLeft: '10px' }} >{row.custId}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.custName}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.custAreaName}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordItems}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordWeight}</span></td>
                                  <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.ordAmt}</span></td>
                                </tr>
                              );
                          })}
                        </tbody>
                        <tfoot>
                          <tr >
                            <th className="cell-left" ><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                            <th colSpan='4'>Total</th>
                            <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                            <th className="cell-right" ><span style={{ paddingRight: '30px' }}>{totalWeight.toFixed(3)}</span></th>
                            <th className="cell-right" ><span style={{ paddingRight: '15px' }}>{totalAmt}</span></th>
                          </tr>
                        </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '45%' }}>
                      <span style={{ marginRight: '10px' }}>Packers Man : </span>
                        <span style={{ padding: '2px' }} >
                            <select
                              value={selectPackers}
                              onChange={(e) => setSelectPackers(e.target.value)}
                            >
                              {packers.map((user) => (
                                  <option key={user.suId} value={user.suId}>
                                    {user.suName}
                                  </option>
                              ))}
                            </select>
                        </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '45%' }}>
                      <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleToPackersTrans}>
                        Pass To Packing
                      </Button>
                      <Button color="primary" style={{ flex: 1 }} onClick={() => setPackTransModalVisible(false)}>
                        Close
                      </Button>
                    </div>
                  </div>
                
              </ModalBody>
            </Modal>      

          {/* Modal for Customer Ledger */}
            <Modal isOpen={ledgerModalVisible} toggle={() => setModalVisible(!ledgerModalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ padding: '2px' }} >Date</th>
                          <th style={{ padding: '2px' }} >Type</th>
                          <th style={{ padding: '2px' }} >Sales</th>
                          <th style={{ padding: '2px', paddingRight: '10px', }} >Pay</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {ledgerData.map((row, index) => {
                            return (
                              <tr key={index} >
                                <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{new Date(row.tr_date).toLocaleDateString("en-GB").replace(/\//g, "-")}</td>
                                <td className="cell-left" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >
                                    {row.tr_type === 'Cash_Back' ? (
                                      <span style={{color:'red'}}>{row.tr_type}</span>
                                    ) : (
                                        <span>{row.tr_type}</span>
                                    )}
                                </td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px'}}> <span style={{ cursor:'pointer'}} onClick={() => handleSalesDetail(row)} >{row.sl_amt === 0 ? '' : row.sl_amt}</span></td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.cr_amt === 0 ? '' : row.cr_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan='2' className="cell-left"style={{ padding: '2px' }} >
                            <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => setLedgerModalVisible(false)}>
                              Close
                            </Button>
                          </th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{ledgerData?.reduce((sum, ledger) => sum + (ledger.sl_amt || 0), 0)}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{ledgerData?.reduce((sum, ledger) => sum + (ledger.cr_amt || 0), 0)}</th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
              </ModalBody>
            </Modal>        

          {/* Modal for Sales Detail */}
            <Modal isOpen={salesDetailModalVisible} toggle={() => setSalesDetailModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <h6>
                    {selectedOrder && `${selectedOrder.custName} - `}
                    {new Date(selectedLedgerData.tr_date)
                      .toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })
                      .replace(/\//g, "-")}
                  </h6>
                  <div>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th colSpan='3' className="cell-left" style={{ padding: '2px' }} >Item</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Qty</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Amount</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {selectedSalesDetail.map((row) => {
                            return (
                              <tr key={row.prd_id} style={{ cursor: 'pointer' }} >
                                <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_qty}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody> 
                      <tfoot>
                        {(selectedLedgerData.sl_amt - (selectedSalesDetail.reduce((sum, item) => sum + item.sd_prd_amt, 0)) < 0) && (
                          <tr>
                            <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>Round off</td>
                            <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} ></td>
                            <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{selectedLedgerData.sl_amt - (selectedSalesDetail.reduce((sum, item) => sum + item.sd_prd_amt, 0))}</td>
                          </tr>
                        )}
                        <tr>
                          <th colSpan='3' className="cell-left"style={{ padding: '2px' }} >
                              <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => {setSalesDetailModalVisible(false); setLedgerModalVisible(true);}}>
                                Close
                              </Button>
                          </th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalWeight.toFixed(3)}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalAmt.toFixed(0)}</th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
              </ModalBody>
            </Modal>    
    </div>
  );
};

export default OrderMaster;
